import { render, staticRenderFns } from "./AddSensitiveWord.vue?vue&type=template&id=6e2b7e79&scoped=true&"
import script from "./AddSensitiveWord.vue?vue&type=script&lang=ts&"
export * from "./AddSensitiveWord.vue?vue&type=script&lang=ts&"
import style0 from "./AddSensitiveWord.vue?vue&type=style&index=0&id=6e2b7e79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b7e79",
  null
  
)

export default component.exports